<p class="modal-title">Admin: Wheel Bets</p>
<div class="body flex flex-col">
  <div
    class="bet--color-row yellow"
    style="justify-content: center !important; margin: 0 auto"
  >
    Roll color: @if (betsResource.hasValue()) {
    @let rollColor = betsResource.value()[0].roll;
    <div
      animate.enter="animate-fade-in"
      class="bet--color {{ rollColor }}"
      [style.--bet-color]="rollColor"
    ></div>
    } @if (betsResource.isLoading()) {
    <app-loading-icon
      [color]="'var(--yellow)'"
      [size]="'16px'"
      animate.enter="animate-fade-in"
    />
    }
  </div>

  <div class="bets scrollbar">
    @if (betsResource.isLoading()) {
    <app-loading-icon
      [color]="'var(--yellow)'"
      [size]="'48px'"
      animate.enter="animate-fade-in"
      class="absolute-center"
    />
    } @else if (betsResource.hasValue()) { @for (bet of betsResource.value();
    track $index) {
    <div class="bet">
      @let player = { steamid: bet.userid, name: bet.name, avatar: bet.avatar };
      <div class="bet--top">
        <app-player-row
          (click)="handleOpenAdminUserProfile(player)"
          [player]="player"
        ></app-player-row>
      </div>
      <div class="bet--balance-row yellow">
        Bet value:
        <app-cost
          [cost]="bet.value"
          [gap]="4"
          [balanceType]="bet.balancetype"
        ></app-cost>
      </div>
      <div
        class="bet--balance-row"
        [class.green]="bet.outcome > 0"
        [class.red]="bet.outcome <= 0"
      >
        Bet outcome:
        <app-cost
          [cost]="bet.outcome"
          [gap]="4"
          [color]="bet.outcome <= 0 ? 'var(--red)' : 'var(--green)'"
          [balanceType]="bet.balancetype"
        ></app-cost>
      </div>
      <div
        class="bet--color-row"
        [class.green]="bet.color === bet.roll"
        [class.red]="bet.color !== bet.roll"
      >
        Bet color:
        <div class="bet--color {{ bet.color }}"></div>
      </div>
    </div>
    } } @else if (betsResource.error()) {
    <div
      animate.enter="animate-fade-in"
      style="text-align: center"
      class="flex flex-col gap-4 items-center justify-center w-full h-full"
    >
      {{ betsResource.error() }}
      <button
        class="button button--style-primary h-32 padding-x-12 rounded-4"
        (click)="betsResource.reload()"
      >
        Reload
      </button>
    </div>
    }
  </div>
</div>
